<template>
  <section class="solicitud-uso py-5">
    <div class="container">
      <h2 class="text-center fw-bold mb-4">Estoy interesado en el Servicio de Araucann</h2>
      <p class="text-center text-muted mb-5">Completá el formulario y nos pondremos en contacto para iniciar el proceso.</p>

      <form @submit.prevent="enviarSolicitud" class="row g-4 justify-content-center" v-if="!enviado">
        <div class="col-md-6">
          <label class="form-label">Nombre completo *</label>
          <input v-model="form.nombre" type="text" class="form-control" required />
        </div>

        <div class="col-md-6">
          <label class="form-label">Email *</label>
          <input v-model="form.email" type="email" class="form-control" required />
        </div>

        <div class="col-md-6">
          <label class="form-label">Teléfono</label>
          <input
            v-model="form.telefono"
            type="text"
            class="form-control"
            pattern="^[0-9+\-\s]*$"
            title="Solo se permiten números, espacios, + y -"
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Organización</label>
          <input v-model="form.organizacion" type="text" class="form-control" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Red social (Instagram, LinkedIn, etc.)</label>
          <input v-model="form.red_social" type="text" class="form-control" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Preferencia de contacto *</label>
          <select v-model="form.preferencia_contacto" class="form-select" required>
            <option disabled value="">Seleccioná una opción</option>
            <option value="email">Email</option>
            <option value="red_social">Red Social</option>
          </select>
        </div>

        <div class="col-md-12">
          <label class="form-label">¿Contás con habilitación legal para cultivo?</label>
          <input
            v-model="form.habilitacion_legal"
            type="text"
            class="form-control"
            placeholder="Ej: ARICCAME vigente, SENASA, Licencia Uruguay, etc."
          />
        </div>

        <div class="col-md-12">
          <label class="form-label">Mensaje adicional</label>
          <textarea v-model="form.mensaje" class="form-control" rows="4" />
        </div>

        <div class="col-12 text-center">
          <button class="btn btn-success px-5" type="submit" :disabled="cargando">Enviar solicitud</button>
          <div v-if="cargando" class="spinner-border text-success" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>
        <div class="col-12 text-center">
          <button class="btn btn-secondary px-5" type="button" @click="cancelarSolicitud">Cancelar</button>
        </div>
      </form>

      <!-- Modal de éxito -->
      <div v-if="enviado" class="modal-exito d-flex flex-column align-items-center justify-content-center">
        <div class="bg-white shadow p-5 rounded text-center" style="max-width: 500px;">
          <font-awesome-icon :icon="['fas', 'circle-check']" class="text-success mb-3 fs-1" />
          <h4 class="fw-bold">¡Solicitud enviada correctamente!</h4>
          <p class="text-muted mb-4">Gracias por tu interés. Nos pondremos en contacto a la brevedad por el medio que has indicado.</p>
          <button class="btn btn-success px-4" @click="aceptarExito">Aceptar</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from '@/axios'

export default {
  name: 'SolicitudUso',
  data() {
    return {
      form: {
        nombre: '',
        email: '',
        telefono: '',
        organizacion: '',
        red_social: '',
        preferencia_contacto: '',
        habilitacion_legal: '',
        mensaje: ''
      },
      enviado: false,
      cargando: false // Añadido estado de carga
    }
  },
  methods: {
    async enviarSolicitud() {
      this.cargando = true // Mostrar animación de carga
      try {
        await axios.post('/api/solicitud_uso_crear', this.form)
        this.enviado = true
        this.resetFormulario()
      } catch (error) {
        console.error('Error al enviar solicitud:', error)
        alert('Ocurrió un error al enviar la solicitud.')
      } finally {
        this.cargando = false // Ocultar animación de carga
      }
    },
    cancelarSolicitud() {
      this.enviado = false
      this.resetFormulario()
      this.$emit('cancelar')
    },
    aceptarExito() {
      this.cancelarSolicitud()
    },
    resetFormulario() {
      this.form = {
        nombre: '',
        email: '',
        telefono: '',
        organizacion: '',
        red_social: '',
        preferencia_contacto: '',
        habilitacion_legal: '',
        mensaje: ''
      }
    }
  }
}
</script>

<style scoped>
.solicitud-uso {
  background-color: #f9f8f6;
  min-height: 100%;
}

.modal-exito {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.5);
  z-index: 1050;
}
</style>
